import React from 'react';
import styles from './Introduction.module.css';
import { CookieService } from '@services/cookie-service';

interface IntroductionProps {
  onStart: () => void;
  onViewResults?: () => void;
}

export const Introduction: React.FC<IntroductionProps> = ({ onStart, onViewResults }) => {
  const hasPreviousResults = CookieService.hasResults();

  return (
    <div className={styles.container}>
      <div className={styles.emoji}>💜</div>

      <h1 className={styles.title}>Bienvenue sur ton bilan cycle féminin 💜</h1>

      <p className={styles.subtitle}>
        Un bilan pour accompagner les femmes qui recherchent des solutions naturelles et efficaces, vraiment adaptées à leur situation.
      </p>

      <div className={styles.features}>
        <div className={styles.feature}>
          <span className={styles.featureIcon}>🌿</span>
          <div className={styles.featureText}>
            <div className={styles.featureTitle}>Pour qui ?</div>
            <div className={styles.featureDescription}>Pour les femmes avec de l'endométriose, des règles douloureuses, le syndrome prémenstruel ou le SOPK</div>
          </div>
        </div>

        <div className={styles.feature}>
          <span className={styles.featureIcon}>✨</span>
          <div className={styles.featureText}>
            <div className={styles.featureTitle}>Le bilan qui vous pose les bonnes questions</div>
            <div className={styles.featureDescription}>
              3 minutes pour faire le point
            </div>
          </div>
        </div>

        <div className={styles.feature}>
          <span className={styles.featureIcon}>🏆</span>
          <div className={styles.featureText}>
            <div className={styles.featureTitle}>Recommandations personnalisées</div>
            <div className={styles.featureDescription}>
              Des produits sélectionnés selon vos besoins
            </div>
          </div>
        </div>
      </div>

      <div className={styles.cta}>
        <button className="btn btn-primary btn-large" onClick={onStart}>
          Commencer le questionnaire
        </button>
        {hasPreviousResults && onViewResults && (
          <button className="btn btn-secondary btn-large" onClick={onViewResults} style={{ marginTop: 'var(--space-md)' }}>
            Voir mes résultats précédents
          </button>
        )}
      </div>

      <div className={styles.privacy}>
        <span>🔒</span>
        <span>Vos données sont confidentielles et sécurisées</span>
      </div>
    </div>
  );
};
